import { COLORS } from "../../../assets/utils/enums/colors";
import { MediumText } from "../../../components/typography";
import FinanceChart, {
  FinanceChartProps,
} from "../../../components/ui/finance-chart";
import StatisticBlock, {
  DataStatisticProps,
} from "../../../components/ui/statistics-block";
import iconStatistic from "../../../assets/images/icons/pie-one-icon.svg";
import FinanceDonutChart, {
  DonutRawData,
} from "../../../components/ui/finance-donat-chart";
import { useStatisticPeriod } from "../../../assets/store/useStatisticPeriod";
import { Button } from "../../../components/ui/button";
import DataTable from "../../../components/ui/table";
import {
  tableColumnType,
  TableTypeEnum,
} from "../../../assets/utils/enums/table";
import { useEffect, useState } from "react";
import getData from "../../../api/project-request";
import { API_URL_FINANCE } from "../../../constants";
import { currencies } from "../../../assets/utils/data/items";
import Loader from "../../../components/ui/loader";
import { FinanceRow } from "../../../assets/utils/table-types";
import { useNavigate } from "react-router-dom";
import { FinanceTypeTable } from "../../../assets/utils/enums/finance";
import { deleteArrFunc } from "../../../assets/utils/request-function";
import { useStructureStore } from "../../../assets/store/useStructureStore";
import { ObjectsEnum } from "../../../assets/utils/enums/basket";
import { useStructureColumnsStore } from "../../../assets/store/useStructureColumnsStore";

export default function ExpenseMainTab() {
  const { period, setPeriod } = useStatisticPeriod();
  const [expenseChart, setExpenseChart] = useState<FinanceChartProps>({});
  const [expensesTable, setExpensesTable] = useState<FinanceRow[]>([]);
  const [mainFinStatistics, setMainFinStatistics] = useState<
    DataStatisticProps[]
  >([]);
  const [expenseDonatChart, setExpenseDonatChart] = useState<DonutRawData[]>(
    []
  );

  const [isDeleted, setIsDeleted] = useState<boolean>(false);
  const navigate = useNavigate();
  const [loaderState, setLoaderState] = useState<boolean>(false);

  const fields = useStructureStore(
    (s) => s.structures[ObjectsEnum.EXPENSE].fields
  )
  const baseColumns =
    tableColumnType[TableTypeEnum.FINANCE].columns;

  const tableStructure = useStructureColumnsStore(
    baseColumns,
    fields
  );

  const getExpensesTable = async () => {
    setLoaderState(true);
    try {
      const data = await getData(`${API_URL_FINANCE}/get-table-expense`);
      if (Array.isArray(data)) {
        setExpensesTable(data);
      } else {
        setExpensesTable([]);
      }
    } catch (error: any) {
      console.log(error.message);
      setExpensesTable([]);
    } finally {
      setTimeout(() => {
        setLoaderState(false);
      }, 100);
    }
  };

  useEffect(() => {
    const getExpenseChartStatistic = async () => {
      setLoaderState(true);
      try {
        const data = await getData(
          `${API_URL_FINANCE}/get-expenses-statistics?currency=${currencies[1].code}`
        );

        if (!data?.data) {
          setExpenseChart({});
          return;
        }

        setExpenseChart(data);
      } catch (error) {
        console.error("❌ Помилка при запиті статистики:", error);
        setExpenseChart({});
      } finally {
        setTimeout(() => {
          setLoaderState(false);
        }, 100);
      }
    };

    getExpenseChartStatistic();
    getExpensesTable();
  }, []);

  useEffect(() => {
    const getExpenseDonatChartStatistic = async () => {
      setLoaderState(true);
      try {
        const data = await getData(
          `${API_URL_FINANCE}/get-expence-statistic-by-period?period=${period}`
        );

        if (!data) {
          setExpenseDonatChart([]);
          return;
        }

        setExpenseDonatChart(data);
      } catch (error) {
        console.error("❌ Помилка при запиті статистики:", error);
        setExpenseDonatChart([]);
      } finally {
        setTimeout(() => {
          setLoaderState(false);
        }, 100);
      }
    };

    const getStatisticFinance = async () => {
      setLoaderState(true);
      const data = await getData(
        `${API_URL_FINANCE}/finance-summary-all?period=${period}&currency=${currencies[1].code}`
      );

      setTimeout(() => {
        setMainFinStatistics([
          {
            title: "Надходження",
            value: data.formattedIncomes,
            percent: `${data.incomesChangePercent}`,
          },
          {
            title: "Витрати",
            value: data.formattedExpenses,
            percent: `${data.expensesChangePercent}`,
          },
        ]);
        setLoaderState(false);
      }, 100);
    };
    getExpenseDonatChartStatistic();
    getStatisticFinance();
  }, [period, isDeleted]);

  useEffect(() => {
    getExpensesTable();
    setIsDeleted(false);
  }, [isDeleted]);

  return (
    <>
      <div className="d-flex flex-column gap-3">
        <div className="d-flex w-100 gap-3">
          <FinanceChart
            year={expenseChart.year}
            currency={expenseChart.currency}
            data={expenseChart.data}
            typeTable={expenseChart.typeTable}
          />
          <div className="w-40 d-flex flex-column justify-content-between gap-3">
            <StatisticBlock
              iconColor={COLORS.warning}
              iconUrl={iconStatistic}
              bgColor={COLORS.white}
              isDropdown={true}
              data={mainFinStatistics}
            />
            <FinanceDonutChart
              type={"expense"}
              title={"Розподіл витрат"}
              data={expenseDonatChart}
              period={period}
              setPeriod={setPeriod}
            />
            <Button
              bgcolor={COLORS.blue}
              txtcolor={COLORS.white}
              brcolor={"transparent"}
              width="auto"
              className="m-0"
              type="large"
              onClick={() => {
                navigate("/finance/expense/add");
              }}
            >
              <MediumText>Додати витрату</MediumText>
            </Button>
          </div>
        </div>
        <DataTable
          table={{ ...tableColumnType[TableTypeEnum.FINANCE], columns: tableStructure }}
          data={expensesTable}
          isFinanceTitle={FinanceTypeTable.EXPENSE}
          deleteArrFunc={(queryArr) =>
            deleteArrFunc(queryArr, `${API_URL_FINANCE}/expenses`, setIsDeleted)
          }
        />
      </div>
      {loaderState && <Loader />}
    </>
  );
}
